/*
<summary>
   This higher-order component is all about wrapping a component with Borrower popup visibility state and its toggle handler.
   Developer: Aashish Singh, Created Date: 01-Sep-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { useState } from 'react';

const BorrowToolPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showBorrowToolPopup, setShowBorrowToolPopup] = useState<boolean>(false);

    const borrowToggleHandler = () => {
      setShowBorrowToolPopup(!showBorrowToolPopup);
    };

    return (
      <Component
        showBorrowToolPopup={showBorrowToolPopup}
        borrowToggleHandler={borrowToggleHandler}
        {...props}
      />
    );
  };

export default BorrowToolPopupHOC;
